import React from "react";
import "./LoadingCircle.css";

function LoadingCircle() {
  return (
    <div className="loading-circle-container">
      <div className="loading-circle"></div>
    </div>
  );
}

export default LoadingCircle;
